/* ARTMiE Variant Popup
   When "Do košíka" is clicked on a multi-variant product card,
   show a popup with variant images so the user can pick one. */

(function () {
  'use strict';

  /* ARTMIE_VP_SI_I18N 2026-05-16 — Slovenian locale support so toast messages and
     close-button aria-label render in Slovenian on artmie.si. Falls back to Slovak otherwise. */
  function _vpIsSi() {
    try {
      var lang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
      if (lang.indexOf('sl') === 0) return true;
      var path = (location.pathname || '').toLowerCase();
      if (path.indexOf('/sl-si') === 0 || path.indexOf('/sk-si') === 0) return true;
      var host = (location.hostname || '').toLowerCase();
      if (host.indexOf('artmie.si') >= 0) return true;
    } catch (e) {}
    return false;
  }

  /* === phase-72 EL+IT i18n === */
  function _vpIsEl() {
    try {
      var lang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
      if (lang.indexOf('el') === 0) return true;
      var path = (location.pathname || '').toLowerCase();
      if (path.indexOf('/el-gr') === 0 || path.indexOf('/sk-gr') === 0) return true;
      var host = (location.hostname || '').toLowerCase();
      if (host.indexOf('artmie.gr') >= 0) return true;
    } catch (e) {}
    return false;
  }
  function _vpIsIt() {
    try {
      var lang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
      if (lang.indexOf('it') === 0) return true;
      var path = (location.pathname || '').toLowerCase();
      if (path.indexOf('/it-it') === 0 || path.indexOf('/sk-it') === 0) return true;
      var host = (location.hostname || '').toLowerCase();
      if (host.indexOf('artmie.it') >= 0) return true;
    } catch (e) {}
    return false;
  }
  /* === phase-72 end === */

  var VP_I18N_SI = {
    'Zavrieť': 'Zapri',
    'Pridané do košíka': 'Dodano v košarico',
    'Chyba pri pridávaní': 'Napaka pri dodajanju',
    'Nepodarilo sa pridať': 'Dodajanje ni uspelo',
    'Chyba: ': 'Napaka: '
  };
  
  /* === phase-72 popup I18N EL+IT === */
  var VP_I18N_EL = {
  "Zavrieť": "Κλείσιμο",
  "Pridané do košíka": "Προστέθηκε στο καλάθι",
  "Chyba pri pridávaní": "Σφάλμα κατά την προσθήκη",
  "Nepodarilo sa pridať": "Η προσθήκη απέτυχε",
  "Chyba: ": "Σφάλμα: "
};
  var VP_I18N_IT = {
  "Zavrieť": "Chiudi",
  "Pridané do košíka": "Aggiunto al carrello",
  "Chyba pri pridávaní": "Errore durante l'aggiunta",
  "Nepodarilo sa pridať": "Aggiunta non riuscita",
  "Chyba: ": "Errore: "
};
  /* === phase-72 end === */
function _vpT(s) {
    if (_vpIsSi()) return VP_I18N_SI[s] || s;
    if (_vpIsEl()) return VP_I18N_EL[s] || s;
    if (_vpIsIt()) return VP_I18N_IT[s] || s;
    return s;
  }

  /* ── Inject styles ── */
  var style = document.createElement('style');
  style.textContent = `
    /* Overlay */
    .artmie-vp-overlay {
      position: fixed;
      inset: 0;
      z-index: 9999;
      background: rgba(0,0,0,.45);
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 16px;
      opacity: 0;
      transition: opacity .2s ease;
      -webkit-overflow-scrolling: touch;
    }
    .artmie-vp-overlay.active { opacity: 1; }

    /* Panel */
    .artmie-vp-panel {
      background: #fff;
      border-radius: 16px;
      max-width: 560px;
      width: 100%;
      max-height: 85vh;
      overflow-y: auto;
      box-shadow: 0 12px 48px rgba(0,0,0,.18);
      transform: translateY(20px);
      transition: transform .25s ease;
      overscroll-behavior: contain;
    }
    .artmie-vp-overlay.active .artmie-vp-panel {
      transform: translateY(0);
    }

    /* Header */
    .artmie-vp-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 16px 20px;
      border-bottom: 1px solid #eee;
      position: sticky;
      top: 0;
      background: #fff;
      z-index: 1;
      border-radius: 16px 16px 0 0;
    }
    .artmie-vp-title {
      font-size: 15px;
      font-weight: 700;
      color: #1a1a1a;
      margin: 0;
      line-height: 1.3;
      flex: 1;
      padding-right: 12px;
    }
    .artmie-vp-close {
      width: 32px;
      height: 32px;
      border: none;
      background: #f2f2f2;
      border-radius: 50%;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      transition: background .15s;
    }
    .artmie-vp-close:hover { background: #e0e0e0; }
    .artmie-vp-close svg { width: 14px; height: 14px; }

    /* Grid */
    .artmie-vp-grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 10px;
      padding: 16px;
    }
    @media (max-width: 420px) {
      .artmie-vp-grid { grid-template-columns: repeat(2, 1fr); gap: 8px; padding: 12px; }
    }

    /* Variant card */
    .artmie-vp-card {
      display: flex;
      flex-direction: column;
      align-items: center;
      border: 2px solid #eee;
      border-radius: 10px;
      padding: 8px;
      cursor: pointer;
      transition: border-color .15s, box-shadow .15s;
      background: #fff;
      text-align: center;
      position: relative;
    }
    .artmie-vp-card:hover {
      border-color: #F95523;
      box-shadow: 0 2px 12px rgba(249,85,35,.12);
    }
    .artmie-vp-card.adding {
      pointer-events: none;
      opacity: .6;
    }
    .artmie-vp-card.added {
      border-color: #22c55e;
      background: #f0fdf4;
    }

    /* Variant image */
    .artmie-vp-img {
      width: 100%;
      aspect-ratio: 1;
      object-fit: contain;
      border-radius: 6px;
      background: #f8f8f8;
    }
    .artmie-vp-img-placeholder {
      width: 100%;
      aspect-ratio: 1;
      background: #f2f2f2;
      border-radius: 6px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #bbb;
      font-size: 12px;
    }

    /* Variant name */
    .artmie-vp-name {
      font-size: 11px;
      font-weight: 500;
      color: #333;
      margin-top: 6px;
      line-height: 1.3;
      word-break: break-word;
    }

    /* Variant price */
    .artmie-vp-price {
      font-size: 12px;
      font-weight: 700;
      color: #1a1a1a;
      margin-top: 3px;
    }

    /* Added checkmark */
    .artmie-vp-card.added::after {
      content: '✓';
      position: absolute;
      top: 6px;
      right: 6px;
      width: 22px;
      height: 22px;
      background: #22c55e;
      color: #fff;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 13px;
      font-weight: 700;
    }

    /* Loading spinner */
    .artmie-vp-loading {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 60px 20px;
    }
    .artmie-vp-spinner {
      width: 32px;
      height: 32px;
      border: 3px solid #eee;
      border-top-color: #F95523;
      border-radius: 50%;
      animation: artmie-vp-spin .6s linear infinite;
    }
    @keyframes artmie-vp-spin { to { transform: rotate(360deg); } }

    /* Lock body scroll */
    body.artmie-vp-open {
      overflow: hidden !important;
    }
  `;
  document.head.appendChild(style);

  /* ── Toast notification ── */
  var toastEl = null;
  var toastTimer = null;
  function showToast(msg) {
    if (!toastEl) {
      var ts = document.createElement('style');
      ts.textContent = [
        '#artmie-toast{',
        '  position:fixed;top:50%;left:50%;transform:translate(-50%,-50%) scale(.9);',
        '  background:#1a1a1a;color:#fff;',
        '  padding:18px 36px;border-radius:14px;',
        '  font-size:17px;font-weight:700;',
        '  box-shadow:0 8px 32px rgba(0,0,0,.28);',
        '  z-index:99999;pointer-events:none;',
        '  opacity:0;transition:opacity .2s ease,transform .2s ease;',
        '  white-space:nowrap;text-align:center;',
        '}',
        '#artmie-toast.visible{opacity:1;transform:translate(-50%,-50%) scale(1);}'
      ].join('\n');
      document.head.appendChild(ts);
      toastEl = document.createElement('div');
      toastEl.id = 'artmie-toast';
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('visible');
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('visible'); }, 2000);
  }

  /* ── Cache for product data ── */
  var productCache = {};

  /* ── Format money (price in cents from .js endpoint) ── */
  function formatMoney(cents) {
    var amount = (parseInt(cents, 10) / 100).toFixed(2).replace('.', ',');
    return amount + ' \u20AC';
  }

  /* ── Get product handle from card ── */
  function getProductHandle(card) {
    var link = card.querySelector('.product-card__link');
    if (!link || !link.href) return null;
    var match = link.href.match(/\/products\/([^?#/]+)/);
    return match ? match[1] : null;
  }

  /* ── Fetch product JS (includes available + featured_image) ── */
  
  /* MARKET_SUBPATH_AWARE — when on /xx-yy/ market subpath, prepend it to /products/ fetches
     so product data and variant titles return in the buyer's market locale (e.g. /de-de/) */
  function _marketPrefix() {
    var m = (typeof window !== 'undefined' && window.location && window.location.pathname || '').match(/^(\/[a-z]{2}-[a-z]{2})\//);
    return m ? m[1] : '';
  }

  function fetchProduct(handle, callback) {
    if (productCache[handle]) {
      callback(null, productCache[handle]);
      return;
    }
    var called = false;
    function safeCallback(err, data) {
      if (called) return;
      called = true;
      callback(err, data);
    }
    var xhr = new XMLHttpRequest();
    xhr.open('GET', _marketPrefix() + '/products/' + handle + '.js');
    xhr.timeout = 5000;
    xhr.onload = function () {
      if (xhr.status === 200) {
        try {
          var data = JSON.parse(xhr.responseText);
          productCache[handle] = data;
          safeCallback(null, data);
        } catch (e) {
          safeCallback(e);
        }
      } else {
        safeCallback(new Error('HTTP ' + xhr.status));
      }
    };
    xhr.onerror = function () { safeCallback(new Error('Network error')); };
    xhr.ontimeout = function () { safeCallback(new Error('Timeout')); };
    xhr.send();
  }

  /* ── Add to cart ── */
  function addToCart(variantId, callback) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
    })
    .then(function (resp) {
      if (!resp.ok) {
        return resp.text().then(function (txt) {
          var msg = 'HTTP ' + resp.status;
          try { msg = JSON.parse(txt).description || JSON.parse(txt).message || msg; } catch (e) {}
          var err = new Error(msg);
          err.shopifyMessage = msg;
          throw err;
        });
      }
      return resp.json();
    })
    .then(function (data) { callback(null, data); })
    .catch(function (err) { callback(err); });
  }

  /* ── Update cart count in header (local increment, no network) ── */
  function updateCartCount() {
    document.querySelectorAll(
      '.cart-count-bubble, [data-cart-count], .header__cart-count, ' +
      '.cart-count, .js-cart-count, [data-cart-item-count]'
    ).forEach(function (el) {
      var current = parseInt(el.textContent, 10) || 0;
      el.textContent = current + 1;
      el.style.display = '';
    });
  }

  /* ── Animate overlay in ── */
  function animateIn(overlay) {
    setTimeout(function () { overlay.classList.add('active'); }, 20);
  }

  /* ── Build and show popup ── */
  function showPopup(product) {
    /* Single-variant product (Default Title) — add directly, no popup */
    var realVariants = product.variants.filter(function(v) { return v.title !== 'Default Title'; });
    if (realVariants.length === 0 && product.variants.length > 0) {
      var v = product.variants[0];
      if (v.available) {
        addToCart(v.id, function(err) {
          if (err) { showToast('\u26A0 ' + (err.shopifyMessage || _vpT('Chyba pri pridávaní'))); return; }
          updateCartCount();
          showToast('\u2713 ' + _vpT('Pridané do košíka'));
        });
      }
      return;
    }

    closePopup();

    var overlay = document.createElement('div');
    overlay.className = 'artmie-vp-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');

    var panel = document.createElement('div');
    panel.className = 'artmie-vp-panel';

    /* Header */
    var header = document.createElement('div');
    header.className = 'artmie-vp-header';

    var title = document.createElement('h3');
    title.className = 'artmie-vp-title';
    title.textContent = product.title;

    var closeBtn = document.createElement('button');
    closeBtn.className = 'artmie-vp-close';
    closeBtn.setAttribute('aria-label', _vpT('Zavrieť'));
    closeBtn.innerHTML = '<svg viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="2"><path d="M1 1l12 12M13 1L1 13"/></svg>';
    closeBtn.addEventListener('click', closePopup);

    header.appendChild(title);
    header.appendChild(closeBtn);
    panel.appendChild(header);

    /* Grid */
    var grid = document.createElement('div');
    grid.className = 'artmie-vp-grid';

    product.variants.forEach(function (variant) {
      if (variant.title === 'Default Title') return;
      if (!variant.available) return;

      var card = document.createElement('div');
      card.className = 'artmie-vp-card';
      card.setAttribute('data-variant-id', variant.id);

      /* Image */
      var imgSrc = null;
      if (variant.featured_image && variant.featured_image.src) {
        imgSrc = variant.featured_image.src;
      } else if (product.featured_image) {
        imgSrc = product.featured_image;
      }

      if (imgSrc) {
        if (imgSrc.indexOf('//') === 0) imgSrc = 'https:' + imgSrc;
        var optimized = imgSrc.indexOf('?') !== -1
          ? imgSrc.replace('?', '?width=300&')
          : imgSrc + '?width=300';
        var img = document.createElement('img');
        img.className = 'artmie-vp-img';
        img.src = optimized;
        img.alt = variant.title;
        img.loading = 'eager';
        img.onerror = function() { this.src = imgSrc; };
        card.appendChild(img);
      } else {
        var placeholder = document.createElement('div');
        placeholder.className = 'artmie-vp-img-placeholder';
        placeholder.textContent = '\u2014';
        card.appendChild(placeholder);
      }

      var name = document.createElement('span');
      name.className = 'artmie-vp-name';
      name.textContent = variant.title;
      card.appendChild(name);

      var price = document.createElement('span');
      price.className = 'artmie-vp-price';
      price.textContent = formatMoney(variant.price);
      card.appendChild(price);

      card.addEventListener('click', function () {
        if (card.classList.contains('adding') || card.classList.contains('added')) return;
        card.classList.add('adding');

        addToCart(variant.id, function (err) {
          card.classList.remove('adding');
          if (err) {
            showToast('\u26A0 ' + _vpT('Chyba: ') + (err.shopifyMessage || err.message || _vpT('Nepodarilo sa pridať')));
            return;
          }
          card.classList.add('added');
          updateCartCount();
          showToast('\u2713 ' + _vpT('Pridané do košíka'));
        });
      });

      grid.appendChild(card);
    });

    panel.appendChild(grid);
    overlay.appendChild(panel);
    document.body.appendChild(overlay);
    document.body.classList.add('artmie-vp-open');
    animateIn(overlay);

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closePopup();
    });
    document.addEventListener('keydown', onEscape);
  }

  function onEscape(e) {
    if (e.key === 'Escape') closePopup();
  }

  function closePopup() {
    var overlay = document.querySelector('.artmie-vp-overlay');
    if (!overlay) return;
    overlay.classList.remove('active');
    document.body.classList.remove('artmie-vp-open');
    document.removeEventListener('keydown', onEscape);
    setTimeout(function () {
      if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
    }, 250);
  }

  /* ── Show loading popup, then swap with content ── */
  function showLoadingAndFetch(handle) {
    closePopup();

    var overlay = document.createElement('div');
    overlay.className = 'artmie-vp-overlay';

    var panel = document.createElement('div');
    panel.className = 'artmie-vp-panel';

    var loading = document.createElement('div');
    loading.className = 'artmie-vp-loading';
    var spinner = document.createElement('div');
    spinner.className = 'artmie-vp-spinner';
    loading.appendChild(spinner);
    panel.appendChild(loading);
    overlay.appendChild(panel);
    document.body.appendChild(overlay);
    document.body.classList.add('artmie-vp-open');
    animateIn(overlay);

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closePopup();
    });
    document.addEventListener('keydown', onEscape);

    fetchProduct(handle, function (err, product) {
      if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
      document.body.classList.remove('artmie-vp-open');
      document.removeEventListener('keydown', onEscape);

      if (err || !product) {
        window.location.href = _marketPrefix() + '/products/' + handle;
        return;
      }

      // Count usable variants (skip Default Title and unavailable)
      var usable = (product.variants || []).filter(function (v) {
        return v && v.title !== 'Default Title' && v.available;
      });

      if (usable.length === 0) {
        // No usable variants — fall back to product page so customer sees state
        window.location.href = _marketPrefix() + '/products/' + handle;
        return;
      }

      if (usable.length === 1) {
        // Only one — add directly, no popup
        addToCart(usable[0].id, function (err2) {
          if (err2) {
            showToast('\u26A0 ' + (err2.shopifyMessage || err2.message || _vpT('Nepodarilo sa pridať')));
            return;
          }
          updateCartCount();
          showToast('\u2713 ' + _vpT('Pridané do košíka'));
        });
        return;
      }

      showPopup(product);
    });
  }

  /* ── Intercept cart button clicks ── FALLBACK_HANDLE_RESOLUTION v2 */
  function resolveHandleAndVariants(btn) {
    var handle = null, variantsSize = null;

    // Strategy 1: <product-card> custom-element ancestor (Horizon collection grid path)
    var card = btn.closest('product-card');
    if (card) {
      var s = parseInt(card.getAttribute('data-product-variants-size'), 10);
      if (!isNaN(s)) variantsSize = s;
      handle = getProductHandle(card);
    }

    // Strategy 2: button-level data attributes (some sections expose them on the button)
    if (!handle && btn.getAttribute('data-product-handle')) handle = btn.getAttribute('data-product-handle');
    if (variantsSize === null && btn.getAttribute('data-product-variants-size')) {
      var s2 = parseInt(btn.getAttribute('data-product-variants-size'), 10);
      if (!isNaN(s2)) variantsSize = s2;
    }

    // Strategy 3: nearest ancestor with [data-product-handle] (recommended, swiper, custom blocks)
    if (!handle) {
      var anc = btn.closest('[data-product-handle]');
      if (anc) handle = anc.getAttribute('data-product-handle');
    }
    if (variantsSize === null) {
      var ancV = btn.closest('[data-product-variants-size]');
      if (ancV) {
        var s3 = parseInt(ancV.getAttribute('data-product-variants-size'), 10);
        if (!isNaN(s3)) variantsSize = s3;
      }
    }

    // Strategy 4: walk up to a card-like container, then find <a href="/products/X">
    if (!handle) {
      var container = btn.closest('[class*="product-card"], [class*="product-tile"], [class*="card"], li, article, .swiper-slide') || btn.parentElement;
      var anchor = null;
      while (container && !anchor) {
        anchor = container.querySelector && container.querySelector('a[href*="/products/"]');
        if (anchor) break;
        container = container.parentElement;
        if (container === document.body) break;
      }
      if (anchor) {
        var m = (anchor.getAttribute('href')||'').match(/\/products\/([^/?#]+)/);
        if (m) handle = decodeURIComponent(m[1]);
      }
    }

    // Strategy 5: form input name="id" with a variant id (for buy-buttons block)
    if (!handle) {
      var form = btn.closest('form[action*="/cart/add"]');
      if (form) {
        var idIn = form.querySelector('[name="id"]');
        if (idIn && idIn.dataset && idIn.dataset.productHandle) handle = idIn.dataset.productHandle;
      }
    }

    return { handle: handle, variantsSize: variantsSize };
  }

  window.addEventListener('click', function (e) {
    var btn = e.target.closest('.product-card-actions__button--cart') ||
              e.target.closest('.quick-add__button--choose');
    if (!btn) return;

    var info = resolveHandleAndVariants(btn);
    if (!info.handle) return; // can't identify product — let default fire

    // Known single-variant: skip popup, let default add fire
    if (info.variantsSize === 1) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    showLoadingAndFetch(info.handle);
  }, true);

})();
